import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const TrashIcon = ({
  width = "24",
  height = "24",
  color = "#1D3E70",
  opacity = "1",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
      >
        <path
          fill={color}
          d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z"
          opacity={opacity}
        ></path>
      </svg>
    </IconWrapper>
  );
};
